import "core-js/modules/es.array.push.js";
import moment from "moment";
import { reactive, onMounted, onUnmounted, getCurrentInstance, computed, watch, h, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { isPassAuth } from "../util/index";
import { useMainStore } from "../pinia/main";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import axios from "axios";
import "vue3-pdf-app/dist/icons/main.css";
window._AMapSecurityConfig = {
  securityJsCode: "d0c579bd371cc891004a21216adac5b9"
};
let backRouteParams = null;
export default {
  name: "Home",
  beforeRouteEnter(to, from, next) {
    if (from.name == "map" && Object.keys(from.params).length) {
      backRouteParams = from.params;
    }
    next();
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const mainStore = useMainStore();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    let data = reactive({
      amount: 0,
      base64: "",
      isShow: false,
      times: [moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD")],
      info: {},
      webDemandDataStatisticsVO: {},
      webOrderDataStatisticsVO: {},
      webTransportHistoryVO: [],
      totalDemand: 0,
      totalOrderAmount: 0,
      totalOrderQuantity: 0
    });
    onMounted(() => {
      checkBalance();
      selectDataStatistics();
      historicalDataQuery();
    });
    const pdfUrlToBase64WithAxios = async url => {
      try {
        // 请求 PDF 文件（注意 responseType 设置为 blob）
        const response = await axios.get(url, {
          responseType: "blob"
        });
        // 转换为 Base64
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            resolve(reader.result);
          };
          reader.onerror = error => {
            reject(error);
          };
          reader.readAsDataURL(response.data);
        });
      } catch (error) {
        console.error("请求失败:", error);
        throw error;
      }
    };

    //查询钱包余额
    const checkBalance = async () => {
      data.amount = ((await globalProperties.$api.checkBalance()) || 0) / 100;
    };
    //数据统计
    const selectDataStatistics = async () => {
      const {
        webDemandDataStatisticsVO,
        webOrderDataStatisticsVO,
        webTransportHistoryVO
      } = await globalProperties.$api.selectDataStatistics();
      data.webDemandDataStatisticsVO = webDemandDataStatisticsVO;
      data.webOrderDataStatisticsVO = webOrderDataStatisticsVO;
      data.webTransportHistoryVO = webTransportHistoryVO;
    };
    // onUnmounted(() => {
    //   backRouteParams = null;
    // });

    const historicalDataQuery = async () => {
      const params = {
        startTime: data.times[0],
        endTime: data.times[1]
      };
      const {
        totalDemand,
        totalOrderQuantity,
        totalOrderAmount
      } = await globalProperties.$api.historicalDataQuery(params);
      data.totalDemand = totalDemand;
      data.totalOrderQuantity = totalOrderQuantity;
      data.totalOrderAmount = totalOrderAmount;
    };
    const setIsShow = () => {
      data.isShow = !data.isShow;
    };
    const changeDate = value => {
      data.times = value;
      historicalDataQuery();
    };
    const toViewOrder = type => {
      mainStore.tabIndex = 2;
      router.push({
        path: "/layout/order",
        query: {
          type
        }
      });
    };
    const toPage = async path => {
      // const pdfUrl =
      //   "https://tcapitest-1314260456.cos.ap-shanghai.myqcloud.com/20260423/407a42763d8940a984a1f4879870302f.pdf";
      // const newAxios = axios.create();
      // const response = await newAxios.get(pdfUrl, { responseType: "blob" });
      // const base64 = await blobToBase64(response.data);

      // const bytes = new Uint8Array(base64.length);
      // for (let i = 0; i < base64.length; i++) {
      //   bytes[i] = base64.charCodeAt(i);
      // }
      // const blob = new Blob([bytes], { type: "application/pdf" });

      // // 4. 生成一个本地短链接 (blob:http://...)
      // data.base64 = URL.createObjectURL(blob);
      // console.log(url,data.base64);
      router.push({
        path
      });
    };
    return {
      toPage,
      isPassAuth,
      data,
      setIsShow,
      zhCn,
      mainStore,
      changeDate,
      historicalDataQuery,
      toViewOrder
    };
  }
};